import store from "~/js/store/store";

export default class Gallery {
  constructor() {
    const contents = document.querySelector('._gallery');
    this.photo = document.querySelectorAll('._photo');
    this.thumbnail = document.querySelectorAll('._thumbnail');
    this.name = document.querySelector('._name');
    this.thumbnails = document.querySelector('._thumbnails');

    this.setup()
  }

  setup() {
    //初期にセットされる写真が0とは限らないのでcurrentを取得
    const currentPhotoNum = Array.from(this.thumbnail).findIndex(element => {
      return element.classList.contains('on');
    })
    if (currentPhotoNum !== false) {
      store.dispatch('setPhotoNum', {
        num: currentPhotoNum
      });
      let target = this.thumbnail[currentPhotoNum];
      if (target != null && target.dataset.name) {
        this.name.textContent = target.dataset.name;
      } else {
        this.name.textContent = "";
      }
    }

    this.thumbnail.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        this.remove();
        let target = event.currentTarget;
        target.classList.add("on");
        if (target.dataset.name) {
          this.name.textContent = target.dataset.name;
        } else {
          this.name.textContent = "";
        }

        this.change(index);
      })
    });

    //一つ目の写真を選択
    //this.thumbnail[0].click();

    this.handleTabsNavigation()

    document.dispatchEvent(new CustomEvent('gallery:finished-setup', { detail: { gallery: this } }))
  }

  remove() {
    this.photo.forEach((elm, index) => {
      elm.classList.remove("on");
      elm.setAttribute('tabindex', '-1');
    });
    this.thumbnail.forEach((elm, index) => {
      elm.classList.remove("on");
    });
  }

  change(index) {
    this.photo[index].classList.add("on");
    this.photo[index].setAttribute('tabindex', '0');
    this.photo[index].parentElement.setAttribute('aria-labelledby', `${this.photo[index].id}`)

    store.dispatch('setPhotoNum', {
      num: index
    });
  }

  handleTabsNavigation() {
    const selectFirstTab = () => {
      selectTab(0);
    }

    const selectLastTab = () => {
      selectTab(this.thumbnail.length - 1);
    }

    const selectTab = (index) => {
      this.thumbnail.forEach(function(tab) {
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
      });

      this.thumbnail[index].setAttribute('aria-selected', 'true');
      this.thumbnail[index].setAttribute('tabindex', 0);
      this.thumbnail[index].focus();
      this.thumbnail[index].click();

      this.thumbnail.forEach(function(tabpanel) {
        tabpanel.classList.remove('on');
      });

      this.thumbnail[index].classList.add('on');
    }

    const selectPreviousTab = () => {
      const activeTab = this.thumbnails.querySelector('._thumbnail[aria-selected="true"]');
      const activeTabIndex = Array.prototype.slice.call(this.thumbnail).indexOf(activeTab);

      if(activeTabIndex > 0) {
        selectTab(activeTabIndex - 1);
      } else {
        selectTab(this.thumbnail.length - 1);
      }
    }

    const selectNextTab = () => {
      const activeTab = this.thumbnails.querySelector('._thumbnail[aria-selected="true"]');
      const activeTabIndex = Array.prototype.slice.call(this.thumbnail).indexOf(activeTab);

      if(activeTabIndex < this.thumbnail.length - 1) {
        selectTab(activeTabIndex + 1);
      } else {
        selectTab(0);
      }
    }

    this.thumbnails.addEventListener('keydown', function(e) {
      switch(e.key) {
        case 'ArrowLeft':
          selectPreviousTab();
          break;

        case 'ArrowRight':
          selectNextTab();
          break;

        case 'Home':
          e.preventDefault()
          selectFirstTab();
          break;

        case 'End':
          e.preventDefault();
          selectLastTab();
          break;
      }
    });
  }
}
